module.exports = __webpack_public_path__ + "assets/img/mkt-industry.c74c9cca.png";